/**
 * CallbackPage
 * 
 * Shows a loading spinner while Auth0 processes the callback.
 * The actual redirect is handled by Auth0Provider's onRedirectCallback.
 * This page only handles error cases.
 */

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from '../LoginPage/LoginPage.module.css';

export const CallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  useEffect(() => {
    if (error) {
      console.error('Auth0 callback error:', error, errorDescription);
      navigate('/login', { replace: true });
    }
  }, [error, errorDescription, navigate]);

  if (error) {
    return (
      <div className={styles.loadingOverlay}>
        <span>Authentication failed. Redirecting...</span>
      </div>
    );
  }

  return (
    <div className={styles.loadingOverlay}>
      <div className={styles.spinner} />
      <span>Completing sign in...</span>
    </div>
  );
};

export default CallbackPage;
